import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "EventSlider",
    component: () =>
        __SERVER__ ? require("./calendar-event-slider-view") : import("./calendar-event-slider-view")
});

export default definition;
